import React, { useState, useContext, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import { Athlete } from './athlete';

import style from './results.module.scss';

import { AppContext } from '../../App';
import { dataFetcher } from '../../Utils/dataFetcher';
import { StyledSelect } from '../StyledSelect';
import { ButtonBar } from '../ButtonBar';
import { GAtrack } from '../../Utils/tracking';
// import { secondsInPast } from '../../Utils/time';
import { NoData } from '../NoData';
import { getTrans } from '../../Utils/translate';
import { Spoiler } from '../Spoiler';
import { CosmosText } from '../../cosmos/web-scoped/react';

let timeout;

const JudgesResults = ({ config }) => {
  const context = React.useContext(AppContext);
  const uriConfig = context.config.uriConfig;
  const animationControls = useAnimation();
  const [listIndex, setListIndex] = useState(undefined);
  const [lastList, setLastList] = useState(undefined);
  const [dataSet, setDataSet] = useState({});
  const [option, setOption] = useState(1);
  const [currentLap, setCurrentLap] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const tabOpened = useContext(AppContext).inView;
  // const { spoiler, setSpoiler } = context;
  const { noContent, noData, lastUpdate } = context.lang;

  useEffect(() => {
    if (config.hasOwnProperty('uriActiveEvent')) {
      dataFetcher(config.uriActiveEvent).then((data) => {
        if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.lists.length > 0 &&
          config.lists[0].eventId === data.event.id
        ) {
          setOption(0);
          setLoading(false);
        } else if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.lists.length > 0 &&
          config.lists[1].eventId === data.event.id
        ) {
          setOption(1);
          setLoading(false);
        } else {
          setOption(0);
          setLoading(false);
        }
      });
    } else {
      setOption(0);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }

    const setData = () => {
      config.lists.forEach(async ({ uri }, index) => {
        const data = await dataFetcher(uri, uriConfig);

        if (data) {
          setDataSet((dataSet) => {
            let newDataSet = { ...dataSet };
            newDataSet[index] = { ...data };

            // check if athlete already in list
            if (data.results) {
              const checkedData = { ...data };
              checkedData.results = [];
              newDataSet[index].results.forEach((result) => {
                if (checkedData.results.length > 0) {
                  const newAthleteId = result.athlete.id + (result.lap ? result.lap : '');
                  result.athlete.id = newAthleteId;
                  const checkedAtheleteIds = [];

                  checkedData.results.forEach((checkedResult) => {
                    checkedAtheleteIds.push(checkedResult.athlete.id);
                  });
                  if (!checkedAtheleteIds.includes(newAthleteId)) {
                    checkedData.results.push(result);
                  }
                } else {
                  checkedData.results.push(result);
                }
              });

              newDataSet[index] = checkedData;
            }

            if (data && data.status && data.status === 'finished') {
              clearTimeout(timeout);
            }
            animationControls.start('visible');
            return newDataSet;
          });
        }
      });

      timeout = setTimeout(
        setData,
        config.pollRateSeconds ? config.pollRateSeconds * 1000 : 15000
      );
    };

    setData();
    animationControls.start('visible');
  }, [config, animationControls, currentLap, tabOpened, uriConfig]);

  // useEffect(() => {
  //   if (!listIndex && dataSet[0]) {
  //     setLastList(dataSet[0]);
  //     setListIndex(0);
  //   }
  // }, [dataSet, listIndex]);
  useEffect(() => {
    if (dataSet[option]) {
      setLastList(dataSet[option]);
      setListIndex(option);
    }
  }, [dataSet, option]);

  const handleChange = (data) => {
    setLastList(dataSet[data.value]);
    setListIndex(data.value);
    setOption(data);

    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Dropdown - ${titles[data.value].label}`,
        widget_type: `Judges Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);
  };

  const handleChangeButtonBar = (data) => {
    setLastList(dataSet[data]);
    setListIndex(data);
    setOption(data);

    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Dropdown - ${titles[data].label}`,
        widget_type: `Judges Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);
  };

  useEffect(() => {
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Navigation`,
        widget_type: `Judges Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkShow = () => {
    return (
      dataSet && !isNaN(listIndex) && dataSet[listIndex] && dataSet[listIndex].results
    );
  };

  const filterAndSort = (data, listType) => {
    switch (listType.toLowerCase()) {
      default:
        return [...data]
          .filter(
            ({ status, result, updated }) =>
              (result.rank &&
                ((listType.toLowerCase() === 'cliff' && result.round_number > 1) ||
                  status === 'result' ||
                  status === 'lap')) ||
              (result.finishing_status && result.finishing_status !== 'unknown')
          )
          .sort((a, b) => {
            let aRank = a.result.rank;
            let bRank = b.result.rank;
            // if (a.result_changes) {
            //   const aRankChange = a.result_changes.filter(
            //     (change) => change.type === 'rank'
            //   )[0];
            //   if (aRankChange) {
            //     const aChangeInPast = secondsInPast(
            //       new Date(aRankChange.updated),
            //       config.delayDataSeconds || 60
            //     );
            //     aRank = aChangeInPast ? aRankChange.current : aRankChange.previous;
            //   }
            // }
            // if (b.result_changes) {
            //   const bRankChange = b.result_changes.filter(
            //     (change) => change.type === 'rank'
            //   )[0];
            //   if (bRankChange) {
            //     const bChangeInPast = secondsInPast(
            //       new Date(bRankChange.updated),
            //       config.delayDataSeconds || 60
            //     );
            //     bRank = bChangeInPast ? bRankChange.current : bRankChange.previous;
            //   }
            // }
            aRank = parseInt(aRank, 10);
            bRank = parseInt(bRank, 10);
            return !aRank ? 1 : !bRank || aRank < bRank ? -1 : aRank > bRank ? 1 : 0;
          });
    }
  };

  const titles = config.lists.map(({ title }, index) => {
    return { label: title, value: index };
  });

  const shallAnimate = (athlete) => {
    if (athlete && Boolean(config.advertising) && Boolean(lastList)) {
      const lastListAthlete = lastList.results.find(
        (knownAthlete) => knownAthlete.athlete.id === athlete.athlete.id
      );

      if (lastListAthlete && lastListAthlete.result.finishing_status === 'finished')
        return false;
      if (!lastListAthlete) return true;

      return (
        lastListAthlete.result.finishing_status !== 'finished' &&
        athlete.result.finishing_status === 'finished'
      );
    }

    // return true;
  };

  // if (spoiler) return <Spoiler onClick={() => setSpoiler(!spoiler)} />;
  return (
    <div className={style.result}>
      {titles && titles.length === 1 ? (
        // if there is just one list make a title
        <h3 className="h3">{titles[0].label}</h3>
      ) : titles && titles.length > 2 ? (
        // if there are more then two lists use StyledSelect
        <StyledSelect
          className={`${style.resultSelect} single`}
          options={titles}
          selectFirst
          onChange={handleChange}
          value={option}
          maxHeight={400}
        />
      ) : (
        // if there are just two lists use ButtonBar
        <>
          {!loading && (
            <ButtonBar
              buttons={titles.map((item, index) => {
                return {
                  text: item.label,
                  active: option === item.value || (index === 0 && !option),
                  index: item.value
                };
              })}
              onClick={handleChangeButtonBar}
            />
          )}
        </>
      )}
      {config.lists[listIndex] && config.lists[listIndex].pagination && (
        <div className="appRow">
          <div className={'pagination'}>
            <span
              className={'paginationArrowWrapper'}
              onClick={() => {
                const newLapNum = currentLap >= 2 ? currentLap - 1 : 1;
                // tagLapChange(newLapNum);
                setCurrentLap(newLapNum);
              }}
              style={{
                cursor: currentLap < 1 ? 'pointer' : 'default'
              }}
            >
              {currentLap > 1 && <span className={'paginationArrow'}></span>}
            </span>

            <span className={'paginationCurrent'} style={{ textAlign: 'left' }}>
              LAP {currentLap}
            </span>
            <span
              className={'paginationArrowWrapper'}
              onClick={() => {
                const newLapNum =
                  currentLap <= config.lists[listIndex].laps - 1
                    ? currentLap + 1
                    : config.lists[listIndex].laps;
                // tagLapChange(newLapNum);
                setCurrentLap(newLapNum);
              }}
              style={{
                cursor: currentLap < config.lists[listIndex].laps ? 'pointer' : 'default'
              }}
            >
              {currentLap < config.lists[listIndex].laps && (
                <span className={'paginationArrow'}></span>
              )}
            </span>
          </div>
        </div>
      )}
      <div className="appRow full-width">
        {checkShow() ? (
          <table className={`${style.table} t`}>
            <tbody>
              {filterAndSort(
                dataSet[listIndex].results,
                config.lists[listIndex].type
              ).map((athlete, index) => {
                return (
                  <Athlete
                    key={`${config.lists[listIndex].type}-${listIndex}-${athlete.athlete.id}`}
                    {...athlete}
                    index={index}
                    advertising={config.advertising}
                    animate={shallAnimate(athlete)}
                    listType={config.lists[listIndex].type || 'lite'}
                    rounds={config.lists[listIndex].rounds || 4}
                    delaySeconds={config.delayDataSeconds || 60}
                    pagination={config.lists[listIndex].pagination}
                    toolTipContent={config.toolTipContent}
                    toolTipOn={config.toolTipOn}
                    showAthleteImage={config.showAthleteImage}
                    crosslinkDetails={
                      config.lists[listIndex].crosslinkDetails || config.crosslinkDetails
                    }
                  />
                );
              })}
            </tbody>
          </table>
        ) : (
          <>
            <NoData noData={getTrans(noData)} noContent={getTrans(noContent)} />
          </>
        )}
      </div>
      {dataSet &&
      !isNaN(listIndex) &&
      dataSet[listIndex] &&
      Array.isArray(dataSet[listIndex].results) &&
      dataSet[listIndex].results.length &&
      (dataSet[listIndex].updated_at || dataSet[listIndex].updated) ? (
        <div className="my-8">
          <div className="separator"></div>
          <CosmosText class="mb-2">
            {getTrans(lastUpdate)}:{' '}
            {new Date(
              dataSet[listIndex].updated || dataSet[listIndex].updated_at
            ).toLocaleTimeString()}
          </CosmosText>
        </div>
      ) : undefined}
    </div>
  );
};

export { JudgesResults };
